export default "__VITE_ASSET__P0R8k8TH__"